module.exports = __webpack_public_path__ + "static/media/miMATIC.db13df23.png";